import { Modal, Button } from 'react-bootstrap';

interface CancelPlanModalProps {
    show: boolean;
    onHide: () => void;
    onConfirmCancel: () => void;
}

export default function UserPlanCancellationModal({
    show,
    onHide,
    onConfirmCancel,
}: CancelPlanModalProps) {
    return (
        <Modal centered show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Cancel Plan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to cancel the plan? The parker(s) will have access until the end of the current billing period.
                </p>
                <div className="d-flex flex-column gap-3 mt-3">
                    <Button variant="danger" onClick={onConfirmCancel}>
                        Confirm Cancellation
                    </Button>
                    <Button variant="outline-secondary" onClick={onHide}>
                        Go Back
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
